import { useForm } from "react-hook-form";
import { useState, useRef, useEffect, memo, RefObject } from "react";
import { Box, Button, Typography } from "@mui/material";

const errorStyle = {
    border: `1px solid black`,
    background: 'pink',
}

const defaultValue = {
    placeholder: "placeholder",
    required: false,
    name: "name",
    type: "type",
    options: "options",
}

const BuilderPage = (props: any) => {
    const [editFormData, setFormData] = useState(defaultValue);
    const { register, handleSubmit, watch, setValue, reset, formState } = useForm();
    const errors = formState.errors;
    const onSubmit = (data: any) => {
        let result = props.items.map((obj: any) => {
            if (obj.id == props.inputId) {
                obj.placeholder = data.placeholder?data.placeholder:"placeholder";
                obj.required = data.required;
                obj.name = data.name?data.name:"name";
                obj.options = data.options || '';
            }
            return obj;
        });
        props.setItems(result);
        props.setInputId('');
        reset();
    }

    useEffect(() => {
        console.log("props.inputId", props.inputId);
        if (props.inputId != "") {
            reset();
            let result = props.items.filter((obj: any) => obj.id == props.inputId);
            setFormData({
                placeholder: result[0].placeholder?result[0].placeholder:"placeHolder",
                required: result[0].required,
                name: result[0].name?result[0].name:"name",
                type: result[0].type,
                options: result[0].options || "",
            });
        } else {
            setFormData({
                placeholder: "placeHolder",
                required: false,
                name: "name",
                type: "",
                options: "",
            });
        }
    }, [props?.inputId]);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box>
                    <label>Name: </label>
                    <input
                        autoComplete="off"
                        defaultValue={editFormData.name}
                        aria-label="name"
                        aria-invalid={errors["name"] ? "true" : "false"}
                        style={{
                            ...(errors["name"] ? errorStyle : null),
                        }}
                        {...register("name", { required: true })}
                    />
                    {errors.name && errors.name["type"] === "required" && (
                        <Typography>This is required.</Typography>
                    )}
                </Box>
                <Box>
                    <label>Placeholder: </label>
                    <input
                        autoComplete="off"
                        defaultValue={editFormData.placeholder}
                        aria-label="placeholder"
                        aria-invalid={errors["placeholder"] ? "true" : "false"}
                        style={{
                            ...(errors["placeholder"] ? errorStyle : null),
                        }}
                        {...register("placeholder", { required: true })}
                    />
                    {errors.placeholder && errors.placeholder["type"] === "required" && (
                        <Typography>This is required.</Typography>
                    )}
                </Box>
                {(editFormData.type === "select" || editFormData.type === "radio") && (
                    <Box>
                        <label>Options:</label>
                        <input
                            key={editFormData.options}
                            defaultValue={editFormData.options}
                            type="text"
                            placeholder="Enter options separate by ;"
                            style={{
                                ...(errors["placeholder"] ? errorStyle : null),
                            }}
                            {...register("options", {
                                required: true,
                            })}
                        />
                        {errors.options && errors.options["type"] === "required" && (
                            <Typography>This is required.</Typography>
                        )}
                    </Box>
                )}
                <Box>
                    <label>Required: </label>
                    <input
                        type="checkbox"
                        {...register("required", { required: false })}
                    />
                </Box>
                <Box>
                    <Button type="submit" variant="outlined">Save</Button>
                </Box>
            </form>
        </>
    )
}

export default memo(BuilderPage)